import { Link } from "react-router-dom";

const owner = {
  name: "Maria Angelica Jardin Cornejo",
  dni: "61342970S",
  address: "Plaza Mayor 11, Ciempozuelos",
  site: "nossabarcafe.com",
  businessName: "Nossa Bar Café",
};

const updatedAt = "18 de julio de 2026";

export function LegalNoticePage() {
  return (
    <LegalShell eyebrow="Información legal" title="Aviso Legal" testId="legal-notice-page">
      <LegalSection title="Titularidad del sitio web" testId="legal-notice-owner">
        <p>En cumplimiento de la normativa aplicable, se informa de que este sitio web es titularidad de {owner.name}, con DNI {owner.dni}, y domicilio en {owner.address}.</p>
        <p>La actividad se desarrolla bajo la denominación comercial {owner.businessName}, bar cafetería ubicado en Ciempozuelos.</p>
      </LegalSection>
      <LegalSection title="Objeto" testId="legal-notice-purpose">
        <p>Este sitio web tiene carácter informativo y permite consultar información sobre el establecimiento, carta, promociones, ubicación, horarios y formas de contacto.</p>
      </LegalSection>
      <LegalSection title="Condiciones de uso" testId="legal-notice-terms">
        <p>La persona usuaria se compromete a utilizar este sitio web de forma lícita, respetuosa y conforme a la buena fe, evitando cualquier uso que pueda dañar la imagen, intereses o derechos de terceros o del titular.</p>
      </LegalSection>
      <LegalSection title="Propiedad intelectual e industrial" testId="legal-notice-ip">
        <p>Los textos, imágenes, logotipos, diseño, contenidos y demás elementos de este sitio web pertenecen a su titular o se utilizan con autorización. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.</p>
      </LegalSection>
      <LegalSection title="Responsabilidad" testId="legal-notice-liability">
        <p>El titular procura mantener la información actualizada, aunque no garantiza la inexistencia de errores puntuales. Los precios, horarios, promociones y disponibilidad pueden variar y deben confirmarse directamente con el establecimiento.</p>
      </LegalSection>
      <LegalSection title="Legislación aplicable" testId="legal-notice-law">
        <p>Este aviso se rige por la legislación española. Para cualquier controversia, las partes se someterán a los juzgados y tribunales que correspondan conforme a la normativa vigente.</p>
      </LegalSection>
      <p className="legal-updated" data-testid="legal-notice-updated">Última actualización: {updatedAt}</p>
    </LegalShell>
  );
}

export function PrivacyPolicyPage() {
  return (
    <LegalShell eyebrow="Protección de datos" title="Política de Privacidad" testId="privacy-policy-page">
      <LegalSection title="Responsable del tratamiento" testId="privacy-owner">
        <p>Responsable: {owner.name}. DNI: {owner.dni}. Dirección: {owner.address}. Sitio web: {owner.site}.</p>
      </LegalSection>
      <LegalSection title="Datos que se pueden tratar" testId="privacy-data">
        <p>Este sitio web no incluye formularios propios de contacto, registro o compra. Si la persona usuaria contacta mediante enlaces externos como WhatsApp, Instagram, TikTok o Google Maps, el tratamiento se realizará también conforme a las políticas de dichas plataformas.</p>
        <p>De forma técnica, pueden tratarse datos de navegación asociados al uso del sitio, especialmente si se aceptan cookies analíticas.</p>
      </LegalSection>
      <LegalSection title="Finalidades" testId="privacy-purpose">
        <p>Los datos se utilizarán para atender consultas o reservas iniciadas por la persona usuaria, facilitar información sobre el establecimiento, mejorar la experiencia de navegación y, si se aceptan cookies, obtener estadísticas de uso del sitio.</p>
      </LegalSection>
      <LegalSection title="Base jurídica" testId="privacy-legal-basis">
        <p>La base jurídica puede ser el consentimiento de la persona usuaria, la ejecución de medidas precontractuales solicitadas por ella, el interés legítimo en mantener la seguridad del sitio y el cumplimiento de obligaciones legales aplicables.</p>
      </LegalSection>
      <LegalSection title="Conservación" testId="privacy-retention">
        <p>Los datos se conservarán durante el tiempo necesario para atender la finalidad correspondiente y, posteriormente, durante los plazos exigidos por la normativa aplicable.</p>
      </LegalSection>
      <LegalSection title="Destinatarios" testId="privacy-recipients">
        <p>No se prevén cesiones de datos salvo obligación legal o uso de proveedores necesarios para el funcionamiento del sitio. Los enlaces externos pueden implicar tratamiento por terceros, como WhatsApp, Instagram, TikTok, Google Maps o servicios de analítica si se aceptan cookies.</p>
      </LegalSection>
      <LegalSection title="Derechos" testId="privacy-rights">
        <p>La persona usuaria puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad dirigiéndose al responsable en la dirección indicada. También puede presentar reclamación ante la Agencia Española de Protección de Datos.</p>
      </LegalSection>
      <LegalSection title="Menores" testId="privacy-minors">
        <p>Este sitio no está dirigido específicamente a menores de edad. Si se detecta tratamiento de datos de menores sin autorización adecuada, se procederá a su eliminación cuando corresponda.</p>
      </LegalSection>
      <p className="legal-updated" data-testid="privacy-updated">Última actualización: {updatedAt}</p>
    </LegalShell>
  );
}

export function CookiePolicyPage() {
  return (
    <LegalShell eyebrow="Preferencias" title="Política de Cookies" testId="cookie-policy-page">
      <LegalSection title="Qué son las cookies" testId="cookies-definition">
        <p>Las cookies son pequeños archivos que se almacenan en el dispositivo de la persona usuaria para permitir el funcionamiento del sitio, recordar preferencias o realizar mediciones estadísticas.</p>
      </LegalSection>
      <LegalSection title="Cookies utilizadas" testId="cookies-used">
        <p>Este sitio puede utilizar cookies técnicas necesarias para recordar la preferencia del banner de cookies y, únicamente si se aceptan, cookies analíticas asociadas a herramientas de medición como Google Analytics y PostHog.</p>
      </LegalSection>
      <LegalSection title="Tipos de cookies" testId="cookies-types">
        <ul>
          <li><strong>Técnicas:</strong> necesarias para recordar decisiones como aceptar o rechazar cookies.</li>
          <li><strong>Analíticas:</strong> ayudan a conocer cómo se utiliza el sitio y mejorar sus contenidos. Solo se activan si la persona usuaria acepta.</li>
        </ul>
      </LegalSection>
      <LegalSection title="Gestión del consentimiento" testId="cookies-consent">
        <p>Al acceder por primera vez al sitio se muestra un banner que permite aceptar o rechazar las cookies analíticas. La decisión queda guardada en el navegador y puede modificarse borrando los datos del sitio desde la configuración del navegador.</p>
      </LegalSection>
      <LegalSection title="Cómo desactivar cookies" testId="cookies-disable">
        <p>Además del banner, la persona usuaria puede bloquear o eliminar cookies desde la configuración de su navegador. La desactivación de cookies técnicas puede afectar a algunas preferencias del sitio.</p>
      </LegalSection>
      <LegalSection title="Más información" testId="cookies-more-info">
        <p>Para conocer cómo se tratan los datos personales, consulta también la <Link to="/politica-privacidad" data-testid="cookies-privacy-link">Política de Privacidad</Link>.</p>
      </LegalSection>
      <p className="legal-updated" data-testid="cookies-updated">Última actualización: {updatedAt}</p>
    </LegalShell>
  );
}

function LegalShell({ eyebrow, title, testId, children }) {
  return (
    <section className="page-section legal-page" data-testid={testId}>
      <div className="page-intro legal-intro">
        <span className="eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</span>
        <h1 data-testid={`${testId}-title`}>{title}</h1>
        <p data-testid={`${testId}-description`}>Borrador informativo estándar adaptado a los datos facilitados para Nossa Bar Café en España.</p>
      </div>
      <div className="legal-content" data-testid={`${testId}-content`}>{children}</div>
    </section>
  );
}

function LegalSection({ title, testId, children }) {
  return (
    <article className="legal-section" data-testid={testId}>
      <h2 data-testid={`${testId}-title`}>{title}</h2>
      {children}
    </article>
  );
}